export default __webpack_public_path__ + "static/media/Denmark.e8cc9261.svg";